import Form from '@searchtrends/webform-processor';
import * as altcha from 'altcha';
import 'altcha/i18n/nl';
window.altcha = altcha;

require('leaflet');

window.hideGoogleMaps = function () {
    document.cookie = "showGoogleMaps=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict";

    location.reload();
}

window.allowGoogleMaps = function () {
    document.cookie = "showGoogleMaps=" + Math.floor(Date.now() / 1000) + "; path=/; SameSite=Strict";
}

window.loadMapsJs = function () {
    initMap();
}

let contactforms = {};
let forms = document.querySelectorAll('form[method="post"]:not(.no-ajax)');
forms.forEach(function (cf, index) {
    contactforms[`sendform_${index}`] = new Form(cf, index).onlyOnce();

    cf.addEventListener('submit', function (e) {
        e.preventDefault();

        contactforms[`sendform_${index}`].post(cf.action)
            .then(response => { console.log(response); });
    });
});

let showCategories = document.querySelector('.show_categories');
let categories = document.querySelector('.abc');
if (showCategories && categories) {
    showCategories.addEventListener('click', function (e) {
        e.preventDefault();

        categories.classList.toggle('hidden');
    })
}

if (document.querySelector('.menu-button')) {
    document.querySelector('.menu-button').addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector('header nav > ul').classList.toggle('hidden');
    })
}

if (document.querySelector('.filter-button')) {
    document.querySelector('.filter-button').addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector('.search-sideframe').classList.toggle('hidden');
    });
}

// document.addEventListener('DOMContentLoaded', () => {
    const widget = document.querySelector('altcha-widget');
    if (widget) {
        widget.addEventListener('verified', (event) => {
            console.log('Verified:', event.detail);
        });

        const observer = new MutationObserver(() => {
            widget.querySelectorAll('a').forEach(a => {
                a.rel = 'nofollow noopener noreferrer';
            });
        });

        observer.observe(widget, { childList: true, subtree: true });
    }
// });
